import { createContext, useContext, type ReactNode } from 'react';

// ─────────────────────────────────────────────────────────────────────
// WHETHER THIS SESSION MAY ASK FOR `adminOverride` (#949), for the booking
// writers that are not `useBookingActions` — the series reservation panel,
// mounted four levels down by four different settings screens, where drilling
// a prop would touch every one of them for one boolean.
//
// The value is `overrideRight()` (lib/api/bookingOverride.ts), computed once
// in the shell from the `/me` union. Outside a provider it is `undefined`,
// which `sendsOverride` reads as «unknown»: the flag goes as asked and the
// server decides — exactly what every writer did before.
// ─────────────────────────────────────────────────────────────────────

const OverrideRightContext = createContext<boolean | null | undefined>(undefined);

export function OverrideRightProvider({
  value,
  children,
}: {
  value: boolean | null;
  children: ReactNode;
}) {
  return <OverrideRightContext.Provider value={value}>{children}</OverrideRightContext.Provider>;
}

/** True, false, or null/undefined for unknown — pass it to `sendsOverride`. */
export function useOverrideRight(): boolean | null | undefined {
  return useContext(OverrideRightContext);
}
